<template>
    <div class="container training">
        <div class="row">
            <div class="col-12 col-lg-3 d-none d-lg-block">            
                <div class="training__thumb">
                    <img v-auth-image="'/photos/'+ article.thumbnail_image_id + '?thumbnail=300'" alt="" class="" v-if="article.main_image_id" />
                </div>
                <p class="training__p training__category">{{ article.created_at }}</p>
                <h3 class="training__name">{{ article.title }}</h3>
            </div>
            <div class="col-12 col-lg-8 offset-lg-1 training__desc">
                <h1>{{ article.title }}</h1>
                <img v-auth-image="'/photos/'+ article.main_image_id" alt="" class="" v-if="article.main_image_id" />
                <div v-html="article.content"></div>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'NewsComponent',
  data () {
    return {
        pending: true,
        article: {}
    }
  },
  beforeRouteEnter(to, from, next) {
    /**
     * Get current user object.
     */
    Vue.axios({
      method: 'get',
      url: '/articles/' + to.params.id
    })
    .then(response => {          
        next(vm => {
            vm.article = response.data.data.article
        })
    })
    .catch(error => next(false))
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/news/NewsComponent.vue